// Learning: the dashboard, the shelf of courses, one course with its modules,
// a lesson with its player, and the leaderboard.

import { defineMessages, plural } from './index'

export default defineMessages(
  {
    // --------------------------------------------------------- dashboard --
    greeting: 'Salom, {name}!',
    greetingNoName: 'Xush kelibsiz!',
    continueTitle: 'Davom etish',
    continueWhere: '{course} · {module}',
    openLesson: 'Darsni ochish',
    waitingTitle: 'Keyingi dars hali yopiq',
    myCourses: 'Kurslarim',
    noActiveCourses: 'Hozir faol kursingiz yo‘q. Barcha kurslaringiz «Kurslarim» sahifasida.',
    dashboardStanding: '{percent}% · {points} ball · {rank}-o‘rin, jami {outOf} kishi',

    // ------------------------------------------------------------- shelf --
    noCoursesTitle: 'Hali kursingiz yo‘q',
    noCoursesHint: 'Sizni hali birorta kursga qo‘shishmagan. Administrator bilan bog‘laning.',
    enrolmentPaused: 'To‘xtatilgan',
    enrolmentFinished: 'Tugatilgan',
    progressOf: '«{title}» kursidagi o‘zlashtirish',
    shelfProgress: '{done}/{total} dars · {percent}%',
    percentDone: '{percent}% tugatilgan',

    // ------------------------------------------------------------ course --
    courseNotFound: 'Kurs topilmadi',
    courseNotFoundHint: 'Bu kurs mavjud emas yoki siz unga yozilmagansiz.',
    continueLesson: 'Davom etish: {title}',
    startLesson: 'Boshlash: {title}',
    noModulesYet: 'Bu kursda hali bo‘lim yo‘q.',
    noLessonsYet: 'Bu bo‘limda hali dars yo‘q.',
    moduleNumber: '{n}-bo‘lim',
    lessonsDoneOf: '{total} ta darsdan {done} tasi tugatilgan',
    opensOn: 'Ochilish vaqti: {date}',
    lessonDone: 'Tugatilgan',
    reasonProgress: 'Avval oldingi darsni tugating.',
    reasonHomework: 'Oldingi darsning uy vazifasi topshirilishi va qabul qilinishi kerak.',
    reasonSchedule: 'Bu bo‘lim hali ochilmagan.',
    reasonAccess: 'Bu bo‘limga kirish yopilgan.',
    reasonUnpublished: 'Bu dars hali chop etilmagan.',
    reasonUnknown: 'Bu dars hozircha mavjud emas.',

    // ------------------------------------------------------------ lesson --
    lessonLoadFailed: 'Darsni ochib bo‘lmadi',
    lessonNotFound: 'Bu dars topilmadi: u o‘chirilgan yoki siz bu kursga yozilmagansiz.',
    lessonShut: 'Dars yopiq',
    lessonNavigation: 'Darslar bo‘ylab o‘tish',
    previousLesson: 'Oldingi dars',
    nextLesson: 'Keyingi dars',
    nextAfterVideo: 'Keyingi dars videoni oxirigacha ko‘rganingizdan so‘ng ochiladi.',
    nextAfterPractice:
      'Keyingi dars barcha amaliy topshiriqlardan o‘tganingizdan so‘ng ochiladi. Hozircha {total} tadan {passed} tasi bajarildi.',
    nextAfterVideoAndPractice:
      'Keyingi dars videoni oxirigacha ko‘rib, barcha amaliy topshiriqlardan o‘tganingizdan so‘ng ochiladi. Hozircha {total} tadan {passed} tasi bajarildi.',
    embeddedMaterial: 'Qo‘shimcha material',
    materials: 'Materiallar',
    audioLabel: 'Audio yozuv',
    sizeBytes: '{n} B',
    sizeKB: '{n} KB',
    sizeMB: '{n} MB',
    ratingQuestion: 'Dars foydali bo‘ldimi?',
    ratingThanks: 'Rahmat, javobingiz saqlandi.',
    ratingFailed: 'Javobingizni saqlab bo‘lmadi. Qayta urinib ko‘ring.',

    // ------------------------------------------------------------ player --
    videoLabel: 'Dars videosi',
    videoLoadFailed: 'Videoni ochib bo‘lmadi. Sahifani yangilab ko‘ring.',
    videoUnsupported: 'Brauzeringiz bu videoni ko‘rsata olmaydi. Boshqa brauzerda ochib ko‘ring.',
    videoNotReady: 'Video hali tayyorlanmoqda. Birozdan keyin sahifani yangilang.',
    videoFailed: 'Bu videoni tayyorlashda xatolik bo‘ldi. O‘qituvchingizga xabar bering.',
    unlockedPart: 'Videoning ochilgan qismi: {percent}%',
    seekHint: 'Videoni faqat ko‘rgan joyingizgacha oldinga o‘tkazish mumkin.',

    // ------------------------------------------------------- leaderboard --
    leaderboard: 'Reyting',
    noBoards: 'Kurslaringizda ballar tizimi yoqilmagan, shuning uchun reyting yo‘q.',
    boardCourse: 'Kurs',
    boardCaption: '«{title}» kursi reytingi',
    colPlace: 'O‘rin',
    colLearner: 'Talaba',
    colPoints: 'Ball',
    unnamedLearner: 'Ismsiz talaba',
    yourPlace: 'Sizning o‘rningiz: {rank} · {points} ball',
  },
  {
    en: {
      greeting: 'Hello, {name}!',
      greetingNoName: 'Welcome!',
      continueTitle: 'Pick up where you left off',
      continueWhere: '{course} · {module}',
      openLesson: 'Open lesson',
      waitingTitle: 'Your next lesson isn’t open yet',
      myCourses: 'My courses',
      noActiveCourses: 'You have no active courses right now. All your courses are under “My courses”.',
      dashboardStanding: (v, lang) =>
        plural(lang, Number(v.points), {
          one: '{percent}% · {n} point · rank {rank} of {outOf}',
          other: '{percent}% · {n} points · rank {rank} of {outOf}',
        }),

      noCoursesTitle: 'No courses yet',
      noCoursesHint: 'You haven’t been added to a course yet. Please contact your administrator.',
      enrolmentPaused: 'Paused',
      enrolmentFinished: 'Finished',
      progressOf: 'Progress in “{title}”',
      shelfProgress: (v, lang) =>
        plural(lang, Number(v.total), {
          one: '{done} of {n} lesson · {percent}%',
          other: '{done} of {n} lessons · {percent}%',
        }),
      percentDone: '{percent}% complete',

      courseNotFound: 'Course not found',
      courseNotFoundHint: 'This course doesn’t exist, or you aren’t enrolled on it.',
      continueLesson: 'Continue: {title}',
      startLesson: 'Start: {title}',
      noModulesYet: 'This course has no modules yet.',
      noLessonsYet: 'No lessons in this module yet.',
      moduleNumber: 'Module {n}',
      lessonsDoneOf: (v, lang) =>
        plural(lang, Number(v.total), {
          one: '{done} of {n} lesson completed',
          other: '{done} of {n} lessons completed',
        }),
      opensOn: 'Opens {date}',
      lessonDone: 'Completed',
      reasonProgress: 'Finish the previous lesson first.',
      reasonHomework: 'The previous lesson’s homework has to be handed in and accepted.',
      reasonSchedule: 'This module hasn’t opened yet.',
      reasonAccess: 'Access to this module is closed.',
      reasonUnpublished: 'This lesson isn’t published yet.',
      reasonUnknown: 'This lesson isn’t available right now.',

      lessonLoadFailed: 'Couldn’t open the lesson',
      lessonNotFound: 'This lesson wasn’t found: it has been deleted, or you aren’t enrolled on its course.',
      lessonShut: 'This lesson is closed',
      lessonNavigation: 'Lesson navigation',
      previousLesson: 'Previous lesson',
      nextLesson: 'Next lesson',
      nextAfterVideo: 'The next lesson opens once you have watched the video to the end.',
      nextAfterPractice: 'The next lesson opens once you pass every practice. So far: {passed} of {total}.',
      nextAfterVideoAndPractice:
        'The next lesson opens once you have watched the video to the end and passed every practice. Practice so far: {passed} of {total}.',
      embeddedMaterial: 'Embedded material',
      materials: 'Materials',
      audioLabel: 'Audio recording',
      sizeBytes: '{n} B',
      sizeKB: '{n} KB',
      sizeMB: '{n} MB',
      ratingQuestion: 'Was this lesson helpful?',
      ratingThanks: 'Thanks — your answer is saved.',
      ratingFailed: 'Your answer couldn’t be saved. Please try again.',

      videoLabel: 'Lesson video',
      videoLoadFailed: 'The video couldn’t be opened. Try reloading the page.',
      videoUnsupported: 'Your browser can’t play this video. Try another browser.',
      videoNotReady: 'The video is still being prepared. Reload the page in a little while.',
      videoFailed: 'Something went wrong while preparing this video. Please tell your teacher.',
      unlockedPart: 'Unlocked part of the video: {percent}%',
      seekHint: 'You can only skip ahead as far as you have watched.',

      leaderboard: 'Leaderboard',
      noBoards: 'None of your courses keeps points, so there is no leaderboard.',
      boardCourse: 'Course',
      boardCaption: 'Leaderboard of “{title}”',
      colPlace: 'Place',
      colLearner: 'Learner',
      colPoints: 'Points',
      unnamedLearner: 'Unnamed learner',
      yourPlace: (v, lang) =>
        plural(lang, Number(v.points), { one: 'Your place: {rank} · {n} point', other: 'Your place: {rank} · {n} points' }),
    },
    ru: {
      greeting: 'Здравствуйте, {name}!',
      greetingNoName: 'Добро пожаловать!',
      continueTitle: 'Продолжить обучение',
      continueWhere: '{course} · {module}',
      openLesson: 'Открыть урок',
      waitingTitle: 'Следующий урок пока закрыт',
      myCourses: 'Мои курсы',
      noActiveCourses: 'Сейчас у вас нет активных курсов. Все ваши курсы — в разделе «Мои курсы».',
      dashboardStanding: (v, lang) =>
        plural(lang, Number(v.points), {
          one: '{percent}% · {n} балл · {rank}-е место из {outOf}',
          few: '{percent}% · {n} балла · {rank}-е место из {outOf}',
          many: '{percent}% · {n} баллов · {rank}-е место из {outOf}',
          other: '{percent}% · {n} балла · {rank}-е место из {outOf}',
        }),

      noCoursesTitle: 'Курсов пока нет',
      noCoursesHint: 'Вас ещё не добавили ни на один курс. Свяжитесь с администратором.',
      enrolmentPaused: 'Приостановлен',
      enrolmentFinished: 'Завершён',
      progressOf: 'Прогресс по курсу «{title}»',
      shelfProgress: (v, lang) =>
        plural(lang, Number(v.total), {
          one: '{done} из {n} урока · {percent}%',
          few: '{done} из {n} уроков · {percent}%',
          many: '{done} из {n} уроков · {percent}%',
          other: '{done} из {n} урока · {percent}%',
        }),
      percentDone: 'Пройдено {percent}%',

      courseNotFound: 'Курс не найден',
      courseNotFoundHint: 'Такого курса нет, или вы на него не записаны.',
      continueLesson: 'Продолжить: {title}',
      startLesson: 'Начать: {title}',
      noModulesYet: 'В этом курсе пока нет модулей.',
      noLessonsYet: 'В этом модуле пока нет уроков.',
      moduleNumber: 'Модуль {n}',
      lessonsDoneOf: (v, lang) =>
        plural(lang, Number(v.total), {
          one: 'Пройдено {done} из {n} урока',
          few: 'Пройдено {done} из {n} уроков',
          many: 'Пройдено {done} из {n} уроков',
          other: 'Пройдено {done} из {n} урока',
        }),
      opensOn: 'Откроется {date}',
      lessonDone: 'Пройден',
      reasonProgress: 'Сначала завершите предыдущий урок.',
      reasonHomework: 'Домашнее задание предыдущего урока нужно сдать, и его должны принять.',
      reasonSchedule: 'Этот модуль ещё не открылся.',
      reasonAccess: 'Доступ к этому модулю закрыт.',
      reasonUnpublished: 'Этот урок ещё не опубликован.',
      reasonUnknown: 'Этот урок сейчас недоступен.',

      lessonLoadFailed: 'Не удалось открыть урок',
      lessonNotFound: 'Урок не найден: его удалили, или вы не записаны на этот курс.',
      lessonShut: 'Урок закрыт',
      lessonNavigation: 'Навигация по урокам',
      previousLesson: 'Предыдущий урок',
      nextLesson: 'Следующий урок',
      nextAfterVideo: 'Следующий урок откроется, когда вы досмотрите видео до конца.',
      nextAfterPractice: 'Следующий урок откроется, когда вы пройдёте все практические задания. Пока пройдено {passed} из {total}.',
      nextAfterVideoAndPractice:
        'Следующий урок откроется, когда вы досмотрите видео до конца и пройдёте все практические задания. Пока пройдено {passed} из {total}.',
      embeddedMaterial: 'Встроенный материал',
      materials: 'Материалы',
      audioLabel: 'Аудиозапись',
      sizeBytes: '{n} Б',
      sizeKB: '{n} КБ',
      sizeMB: '{n} МБ',
      ratingQuestion: 'Урок был полезен?',
      ratingThanks: 'Спасибо, ответ сохранён.',
      ratingFailed: 'Не удалось сохранить ответ. Попробуйте ещё раз.',

      videoLabel: 'Видео урока',
      videoLoadFailed: 'Не удалось открыть видео. Попробуйте обновить страницу.',
      videoUnsupported: 'Ваш браузер не может воспроизвести это видео. Попробуйте другой браузер.',
      videoNotReady: 'Видео ещё готовится. Обновите страницу чуть позже.',
      videoFailed: 'При подготовке видео произошла ошибка. Сообщите преподавателю.',
      unlockedPart: 'Открытая часть видео: {percent}%',
      seekHint: 'Перематывать вперёд можно только до места, которое вы уже посмотрели.',

      leaderboard: 'Рейтинг',
      noBoards: 'Ни в одном из ваших курсов нет баллов, поэтому рейтинга нет.',
      boardCourse: 'Курс',
      boardCaption: 'Рейтинг курса «{title}»',
      colPlace: 'Место',
      colLearner: 'Студент',
      colPoints: 'Баллы',
      unnamedLearner: 'Студент без имени',
      yourPlace: (v, lang) =>
        plural(lang, Number(v.points), {
          one: 'Ваше место: {rank} · {n} балл',
          few: 'Ваше место: {rank} · {n} балла',
          many: 'Ваше место: {rank} · {n} баллов',
          other: 'Ваше место: {rank} · {n} балла',
        }),
    },
    de: {
      greeting: 'Hallo, {name}!',
      greetingNoName: 'Willkommen!',
      continueTitle: 'Weitermachen',
      continueWhere: '{course} · {module}',
      openLesson: 'Lektion öffnen',
      waitingTitle: 'Die nächste Lektion ist noch nicht offen',
      myCourses: 'Meine Kurse',
      noActiveCourses: 'Sie haben gerade keine aktiven Kurse. Alle Ihre Kurse finden Sie unter „Meine Kurse“.',
      dashboardStanding: (v, lang) =>
        plural(lang, Number(v.points), {
          one: '{percent} % · {n} Punkt · Platz {rank} von {outOf}',
          other: '{percent} % · {n} Punkte · Platz {rank} von {outOf}',
        }),

      noCoursesTitle: 'Noch keine Kurse',
      noCoursesHint: 'Sie wurden noch keinem Kurs hinzugefügt. Wenden Sie sich an die Verwaltung.',
      enrolmentPaused: 'Pausiert',
      enrolmentFinished: 'Abgeschlossen',
      progressOf: 'Fortschritt in „{title}“',
      shelfProgress: (v, lang) =>
        plural(lang, Number(v.total), {
          one: '{done} von {n} Lektion · {percent} %',
          other: '{done} von {n} Lektionen · {percent} %',
        }),
      percentDone: '{percent} % abgeschlossen',

      courseNotFound: 'Kurs nicht gefunden',
      courseNotFoundHint: 'Diesen Kurs gibt es nicht, oder Sie sind nicht eingeschrieben.',
      continueLesson: 'Weiter: {title}',
      startLesson: 'Starten: {title}',
      noModulesYet: 'Dieser Kurs hat noch keine Module.',
      noLessonsYet: 'In diesem Modul gibt es noch keine Lektionen.',
      moduleNumber: 'Modul {n}',
      lessonsDoneOf: (v, lang) =>
        plural(lang, Number(v.total), {
          one: '{done} von {n} Lektion abgeschlossen',
          other: '{done} von {n} Lektionen abgeschlossen',
        }),
      opensOn: 'Öffnet am {date}',
      lessonDone: 'Abgeschlossen',
      reasonProgress: 'Schließen Sie zuerst die vorige Lektion ab.',
      reasonHomework: 'Die Hausaufgabe der vorigen Lektion muss abgegeben und angenommen sein.',
      reasonSchedule: 'Dieses Modul ist noch nicht geöffnet.',
      reasonAccess: 'Der Zugang zu diesem Modul ist geschlossen.',
      reasonUnpublished: 'Diese Lektion ist noch nicht veröffentlicht.',
      reasonUnknown: 'Diese Lektion ist gerade nicht verfügbar.',

      lessonLoadFailed: 'Die Lektion konnte nicht geöffnet werden',
      lessonNotFound: 'Diese Lektion wurde nicht gefunden: Sie wurde gelöscht, oder Sie sind nicht in ihren Kurs eingeschrieben.',
      lessonShut: 'Lektion geschlossen',
      lessonNavigation: 'Navigation zwischen Lektionen',
      previousLesson: 'Vorige Lektion',
      nextLesson: 'Nächste Lektion',
      nextAfterVideo: 'Die nächste Lektion öffnet sich, sobald Sie das Video bis zum Ende angesehen haben.',
      nextAfterPractice: 'Die nächste Lektion öffnet sich, sobald Sie alle Übungen bestanden haben. Bisher: {passed} von {total}.',
      nextAfterVideoAndPractice:
        'Die nächste Lektion öffnet sich, sobald Sie das Video bis zum Ende angesehen und alle Übungen bestanden haben. Bisher: {passed} von {total} Übungen.',
      embeddedMaterial: 'Eingebettetes Material',
      materials: 'Materialien',
      audioLabel: 'Audioaufnahme',
      sizeBytes: '{n} B',
      sizeKB: '{n} KB',
      sizeMB: '{n} MB',
      ratingQuestion: 'War diese Lektion hilfreich?',
      ratingThanks: 'Danke, Ihre Antwort ist gespeichert.',
      ratingFailed: 'Ihre Antwort konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',

      videoLabel: 'Lektionsvideo',
      videoLoadFailed: 'Das Video konnte nicht geöffnet werden. Laden Sie die Seite neu.',
      videoUnsupported: 'Ihr Browser kann dieses Video nicht abspielen. Versuchen Sie einen anderen Browser.',
      videoNotReady: 'Das Video wird noch vorbereitet. Laden Sie die Seite gleich neu.',
      videoFailed: 'Beim Vorbereiten dieses Videos ist ein Fehler aufgetreten. Bitte geben Sie Ihrer Lehrkraft Bescheid.',
      unlockedPart: 'Freigeschalteter Teil des Videos: {percent} %',
      seekHint: 'Vorspulen geht nur bis zu der Stelle, die Sie schon gesehen haben.',

      leaderboard: 'Rangliste',
      noBoards: 'Keiner Ihrer Kurse vergibt Punkte, daher gibt es keine Rangliste.',
      boardCourse: 'Kurs',
      boardCaption: 'Rangliste von „{title}“',
      colPlace: 'Platz',
      colLearner: 'Lernende Person',
      colPoints: 'Punkte',
      unnamedLearner: 'Ohne Namen',
      yourPlace: (v, lang) =>
        plural(lang, Number(v.points), { one: 'Ihr Platz: {rank} · {n} Punkt', other: 'Ihr Platz: {rank} · {n} Punkte' }),
    },
  },
)
